/**
 * WordPress dependencies
 */
import { _x } from '@safe-wordpress/i18n';

export function getQueryArgError( url: string ): false | string {
	if ( -1 !== url.indexOf( '?' ) ) {
		return _x(
			'Tested URLs should not contain query arguments',
			'text',
			'nelio-ab-testing'
		);
	}
	return false;
}
